<template>
  <div v-if="vacancy" class="bi-table-card--item-details">
    <router-link
      :to="{
        name: 'project.edit.sub',
        params: { id: vacancy.project.id, page: vacancy.id }
      }"
      ><h5>{{ vacancy.title }}</h5></router-link
    >
    <p><i class="fas fa-hashtag"></i>{{ vacancy.number }}</p>
    <p v-if="vacancy.project.userGroup">
      <i class="fal fa-map-marker-alt"></i>
      {{ vacancy.project.userGroup.name }}
    </p>
  </div>
</template>
<script>
import gql from "graphql-tag";

export default {
  props: {
    id: {
      required: true
    }
  },
  data() {
    return { vacancy: null };
  },
  apollo: {
    vacancy: {
      query: gql`
        query Vacancy($id: ID!) {
          vacancy(id: $id) {
            id
            number
            title
            project {
              id
              userGroup {
                id
                name
              }
            }
          }
        }
      `,
      skip() {
        return !this.id;
      },
      variables() {
        return {
          id: this.id
        };
      }
    }
  },
  mounted() {
    //console.log(this);
  }
};
</script>
